import { Box, Container, Divider, Image, Link, SimpleGrid, Stack, Text, Center, Flex } from "@chakra-ui/react";
import React from "react";
import instagram from "../../Assets/instagram.svg";
import { AppStoreLinks } from "../AppStoreLinks/AppStoreLinks";
import { Mail } from "lucide-react";

const logo = process.env.PUBLIC_URL + "/logos/31Gauge_Horizontal.svg";

const footerLinks = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "MCQs", href: "#mcqs" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  return (
    <Box>
      <Box bg="#293452">
        <Container as={Stack} maxW="1200px" px={{ base: "5", md: "8" }} py={{ base: 10, md: 14 }}>
          <SimpleGrid
            templateColumns={{ base: "1fr", md: "2fr 1fr 1fr", lg: "2fr 1fr 1fr 1.5fr" }}
            spacing={{ base: 10, md: 16 }}
          >
            {/* Brand */}
            <Stack spacing={6}>
              <Image
                h={{ base: "32px", lg: "36px" }}
                src={logo}
                alt="31Gauge"
                filter="brightness(0) invert(1)"
                w="fit-content"
              />
              <Text
                fontFamily="'Inter', sans-serif"
                fontSize="0.9375rem"
                color="rgba(255,255,255,0.55)"
                maxW="300px"
                lineHeight="1.8"
              >
                31Gauge builds structured nursing study guides and concept-driven MCQs
                aligned to the Indian Nursing Council curriculum.
              </Text>
              <Link
                href="https://www.instagram.com/31gaugecentral?igsh=aDRtaThvOTVkdDJ3"
                target="_blank"
                rel="noopener noreferrer"
                w="fit-content"
              >
                <Flex
                  align="center"
                  gap={2}
                  opacity="0.6"
                  _hover={{ opacity: 1 }}
                  transition="opacity 0.2s"
                >
                  <Image src={instagram} alt="Instagram" h="20px" filter="brightness(0) invert(1)" />
                  <Text
                    fontFamily="'Inter', sans-serif"
                    fontSize="0.875rem"
                    color="rgba(255,255,255,0.8)"
                  >
                    @31gaugecentral
                  </Text>
                </Flex>
              </Link>
            </Stack>

            {/* Quick links */}
            <Stack spacing={4}>
              <Text
                fontFamily="'Public Sans', sans-serif"
                fontWeight="600"
                fontSize="0.9375rem"
                color="white"
                mb={1}
              >
                Quick Links
              </Text>
              <Divider borderColor="rgba(255,255,255,0.1)" />
              {footerLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  fontFamily="'Inter', sans-serif"
                  fontSize="0.9375rem"
                  color="rgba(255,255,255,0.55)"
                  _hover={{ color: "#0095C8", textDecoration: "none" }}
                  transition="color 0.2s"
                >
                  {link.label}
                </Link>
              ))}
            </Stack>

            {/* Contact */}
            <Stack spacing={4}>
              <Text
                fontFamily="'Public Sans', sans-serif"
                fontWeight="600"
                fontSize="0.9375rem"
                color="white"
                mb={1}
              >
                Get in Touch
              </Text>
              <Divider borderColor="rgba(255,255,255,0.1)" />
              <Link
                href="mailto:developer@31gauge.com"
                display="inline-flex"
                alignItems="center"
                gap={2}
                fontFamily="'Inter', sans-serif"
                fontSize="0.9375rem"
                color="rgba(255,255,255,0.55)"
                _hover={{ color: "#0095C8", textDecoration: "none" }}
                transition="color 0.2s"
              >
                <Mail size={17} strokeWidth={1.8} aria-hidden="true" />
                developer@31gauge.com
              </Link>
              <Link
                href="https://www.instagram.com/31gaugecentral?igsh=aDRtaThvOTVkdDJ3"
                target="_blank"
                rel="noopener noreferrer"
                display="inline-flex"
                alignItems="center"
                gap={2}
                fontFamily="'Inter', sans-serif"
                fontSize="0.9375rem"
                color="rgba(255,255,255,0.55)"
                _hover={{ color: "#0095C8", textDecoration: "none" }}
                transition="color 0.2s"
              >
                <Image
                  src={instagram}
                  alt=""
                  aria-hidden="true"
                  h="17px"
                  filter="brightness(0) invert(1)"
                  opacity="0.7"
                />
                Instagram
              </Link>
            </Stack>

            {/* App downloads */}
            <Stack spacing={4}>
              <Text
                fontFamily="'Public Sans', sans-serif"
                fontWeight="600"
                fontSize="0.9375rem"
                color="white"
                mb={1}
              >
                Download the App
              </Text>
              <Divider borderColor="rgba(255,255,255,0.1)" />
              <AppStoreLinks align="flex-start" compact location="footer" />
            </Stack>
          </SimpleGrid>
        </Container>
      </Box>

      <Center bg="#1e2a42" py={5}>
        <Text
          fontFamily="'Inter', sans-serif"
          fontSize="0.8125rem"
          color="rgba(255,255,255,0.3)"
        >
          © 2025 31Gauge by Vetkai Health & Education. All rights reserved.
        </Text>
      </Center>
    </Box>
  );
};
